import React, { useEffect, useState, Fragment } from 'react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/3qcv3qHczgxVwHWZbSCfHM/ChatGPT-Image-26-jun-2026_-08_57_38-p.m..webp';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 10
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 2;
          minutes = 45;
          seconds = 10;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-14 px-4 sm:px-6 bg-brand-paper border-b border-gray-200 scroll-mt-4" data-id="element-159" data-mp="32jspnb73pbuo">
      <div className="text-center mb-10" data-id="element-160" data-mp="37idtrlph4foe">
        <p className="text-xs font-black text-brand-gold uppercase tracking-widest mb-3" data-id="element-161" data-mp="37l9qj6pl4yb9">
          SPECIAL OFFER — COMPLETE 6-IN-1 SYSTEM
        </p>
        <p className="text-sm font-bold text-brand-ink mb-5 leading-tight" data-id="element-162" data-mp="2xskh0hdlhuik">
          Get instant access today and transform the way you manage your
          clinical practice.
        </p>
        <div className="inline-block bg-brand-navy text-white px-5 py-2.5 rounded-lg shadow-md mb-8" data-id="element-163" data-mp="2ot7ek8nw267c">
          <p className="font-bold text-sm tracking-wide uppercase" data-id="element-164" data-mp="29wq6bqazx7p0">
            🩺 PHYSIO READY™ — Complete 6-in-1 Clinical Resource System
          </p>
        </div>

        <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-165" data-mp="84aaitbpgxd1">
          <img src={PRODUCT_IMG} alt="Physio Ready Box Set" className="w-full max-w-[400px] mx-auto object-contain drop-shadow-xl hover:scale-[1.02] transition-transform duration-300 mb-4" data-id="element-166" data-mp="8539370iggk3" />
        </a>
      </div>

      <div className="bg-white border-4 border-brand-navy rounded-2xl p-8 text-center relative mb-8 shadow-2xl max-w-lg mx-auto" data-id="element-167" data-mp="6mv5hqqwotoo">
        <div className="mb-8" data-id="element-168" data-mp="1ojuvdssef5e">
          <p className="text-sm font-bold text-brand-ink/50 mb-2" data-id="element-169" data-mp="3truaayijeayu">
            Regular Price: <span className="line-through" data-id="element-170" data-mp="3ttxc0ft1xsje">$97</span>
          </p>
          <p className="text-base font-black text-brand-gold mb-3 uppercase tracking-wide" data-id="element-171" data-mp="ube57hvw3y55">
            🔥 72% OFF — LIMITED-TIME LAUNCH OFFER
          </p>
          <p className="text-6xl font-heading font-black text-brand-navy mb-2 leading-none" data-id="element-172" data-mp="kmnvfjulz5vl">
            $27 USD
          </p>
          <p className="text-[11px] font-bold text-brand-ink/50 uppercase tracking-wider mt-3" data-id="element-173" data-mp="gm3v67eqnm58">
            Pay securely in your local currency.
          </p>
        </div>

        <div className="bg-brand-paper border border-brand-navy/20 rounded-xl p-5 mb-8" data-id="element-174" data-mp="18cqkrs751xqi">
          <p className="text-xs font-bold text-brand-navy mb-4 uppercase tracking-tight" data-id="element-175" data-mp="2qz8avlpqpaws">
            🔥 Last Chance! This special price expires when the countdown
            reaches zero.
          </p>
          <div className="flex justify-center gap-4" data-id="element-176" data-mp="2zzwrmo6ippdd">
            {[{
            v: timeLeft.hours,
            l: 'HOURS'
          }, {
            v: timeLeft.minutes,
            l: 'MINUTES'
          }, {
            v: timeLeft.seconds,
            l: 'SECONDS'
          }].map((unit, idx) => <Fragment key={unit.l} data-id="element-177" data-mp="3jo5rzli7t1ny" data-mpi={idx}>
                {idx > 0 && <div className="text-2xl font-black text-brand-ink/30 mt-2" data-id="element-178" data-mp="3jq0cwzthkts1">
                    :
                  </div>}
                <div className="text-center" data-id="element-179" data-mp="3sp3uu0gx334y">
                  <div className="bg-brand-navy text-white font-mono text-3xl font-bold px-4 py-3 rounded-lg shadow-inner leading-none min-w-[64px]" data-id="element-180" data-mp="3sqf0k5txakyp">
                    {String(unit.v).padStart(2, '0')}
                  </div>
                  <p className="text-[10px] font-bold text-brand-ink/60 mt-2 tracking-wider uppercase" data-id="element-181" data-mp="3f1v3mzg7cb1f">
                    {unit.l}
                  </p>
                </div>
              </Fragment>)}
          </div>
        </div>

        <CTAButton checkout data-id="element-182" data-mp="3ospvcjc7w2u9">🚀 YES! I WANT MY COMPLETE 6-IN-1 SYSTEM</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-8 text-xs text-brand-navy font-bold" data-id="element-183" data-mp="31358hpcy0lfp">
        <div className="flex items-center gap-1.5" data-id="element-184" data-mp="2w4txhbaww4vw">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-185" data-mp="3b0t4eimabyzg" />
          <span data-id="element-186" data-mp="3axx78wi9hec2">4.9/5 — Verified Professional Reviews</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-187" data-mp="35zvmm756t6yh">
          <Shield className="w-4 h-4 text-brand-sage" data-id="element-188" data-mp="q9j5j9ww8cn5" />
          <span data-id="element-189" data-mp="qc5dhanp4u5w">7-Day Money-Back Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}